import React from "react";
import ValidationForm from "../../../../validation/form";
import LocalShippingZone from "./localShippingZone";
import LocalRates from "./localRates";

class Index extends ValidationForm {
  state = {
    showRatesSetup: false,
    currentZone: {},
  };

  render() {
    let currentView;
    if (this.state.showRatesSetup) {
      currentView = (
        <LocalRates
          goBackAction={() =>
            this.setState({
              showRatesSetup: false,
            })
          }
          currentZone={this.state.currentZone}
        />
      );
    } else {
      currentView = (
        <LocalShippingZone
          showRates={(currentZone) =>
            this.setState({ showRatesSetup: true, currentZone })
          }
        />
      );
    }

    return currentView;
  }
}

export default Index;
